import { render, staticRenderFns } from "./BasicMailDriver.vue?vue&type=template&id=0ad022ba&"
import script from "./BasicMailDriver.vue?vue&type=script&lang=js&"
export * from "./BasicMailDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad022ba')) {
      api.createRecord('0ad022ba', component.options)
    } else {
      api.reload('0ad022ba', component.options)
    }
    module.hot.accept("./BasicMailDriver.vue?vue&type=template&id=0ad022ba&", function () {
      api.rerender('0ad022ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/mail-driver/BasicMailDriver.vue"
export default component.exports